import classnames from 'classnames';
import he from 'he';
const SpeakerList = ({ data = [] }) => {
	if (!data || data.length === 0) {
		return null;
	}

	const speakerList = data.map((speaker, index) => {
		const {
			images: { small = [] },
			name = '',
			job_position: jobPosition = '',
			company = '',
			host_role: hostRole = '',
			is_host: isHost = '',
		} = speaker;

		const mainClasses = classnames([
			'cfs-speaker',
			isHost ? 'cfs-speaker--is-host' : '',
		]);

		return (
			<div className={mainClasses} key={index}>
				<div className="cfs-speaker-avatar">
					{small && (
						<img
							alt={name}
							src={small[0]}
							width={small[1]}
							height={small[2]}
						/>
					)}
				</div>
				<div className="cfs-speaker-details">
					<h4 className="cfs-speaker__name">
						{he.decode(name)}{' '}
						{hostRole && <small>({hostRole})</small>}
					</h4>
					<p className="cfs-speaker__position">
						{jobPosition && he.decode(jobPosition)} {jobPosition && company && 'at'}{' '}
						{company && he.decode(company)}
					</p>
				</div>
			</div>
		);
	});

	return <div className="cfs-speakers">{speakerList}</div>;
};
export default SpeakerList;
